/* eslint-disable no-template-curly-in-string */
export type ProjectEnvVariablesType = {
  [key: string]: string;
  // TODO(@fabric-ui) fix
  // [K in keyof ImportMetaEnv]: string;
};

// Environment Variable Template to Be Replaced at Runtime
const projectEnvVariables: ProjectEnvVariablesType = {
  VITE_API_URL: '${VITE_API_URL}',
  VITE_AUTH_AUDIENCE: '${VITE_AUTH_AUDIENCE}',
  VITE_AUTH_DOMAIN: '${VITE_AUTH_DOMAIN}',
  VITE_DD_CLIENT_TOKEN: '${VITE_DD_CLIENT_TOKEN}',
  VITE_SENTRY_DSN: '${VITE_SENTRY_DSN}',
  VITE_ENV: '${VITE_ENV}',
  VITE_PENDO_API_KEY: '${VITE_PENDO_API_KEY}',
  VITE_TEMPORAL: '${VITE_TEMPORAL}',
  VITE_TEMPORAL_NAMESPACE: '${VITE_TEMPORAL_NAMESPACE}',
  VITE_WEBHOOK_URL: '${VITE_WEBHOOK_URL}',
  VITE_WEBSERVER_API_URL: '${VITE_WEBSERVER_API_URL}',
  VITE_VERSION: '${VITE_VERSION}',
  BASE_URL: '${BASE_URL}',
  DEV: '${DEV}',
  MODE: '${MODE}',
  PROD: '${PROD}',
  SSR: '${SSR}',
  STORYBOOK: '${STORYBOOK}',
  VITE_SKIP_AUTH: '${VITE_SKIP_AUTH}',
  VITE_ZID_SUPPORT: '${VITE_ZID_SUPPORT}',
  VITE_SALESFORCE_ENDPOINT: '${VITE_SALESFORCE_ENDPOINT}',
};

export default projectEnvVariables;
